import type { ReactNode } from "react";

/**
 * The pages each solution adds inside a business (its address under /<business>). They mount only where the
 * solution is switched on. Each solution's admin module registers its own here.
 */
export interface SolutionRoute {
  solution: string;
  path: string;
  element: ReactNode;
  /** Shown without the sidebar (a phone page such as check-in at the door). */
  bare?: boolean;
}

import * as events from "./events";
import * as people from "./people";
import * as partners from "./partners";
import * as loops from "./loops";
import * as recaps from "./recaps";
import * as shop from "./shop";
import * as media from "./media";
import * as marketing from "./marketing";
import * as website from "./website";
import * as legal from "./legal";
import * as sales from "./sales";
import * as finance from "./finance";
import * as analytics from "./analytics";
import * as newsroom from "./newsroom";
import * as social from "./social";
import * as meetings from "./meetings";
import * as giveaways from "./giveaways";
import * as collaborations from "./collaborations";

export const SOLUTION_ROUTES: SolutionRoute[] = [...events.routes, ...people.routes, ...partners.routes, ...loops.routes, ...recaps.routes, ...shop.routes, ...media.routes, ...marketing.routes, ...website.routes, ...legal.routes, ...sales.routes, ...finance.routes, ...analytics.routes, ...newsroom.routes, ...social.routes, ...meetings.routes, ...giveaways.routes, ...collaborations.routes];
